export const REGEX_PATTERNS = {
  YEAR: /^\d{4}$/,
  MOBILE: /^(?:98|\+98|0098|0)?9[0-9]{9}$/,
  FTP_PATH: /^(ftp):\/\/[^ "]+$/,
  URL : /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/
};





